"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var _theming = require("../theming");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getSquishedPadding = function getSquishedPadding(props) {
  if (props.isSquished && typeof props.verticalSize === 'undefined') {
    return (0, _styledComponents.css)(["padding-top:", "px;padding-bottom:", "px;"], props.size / 2, props.size / 2);
  }

  return null;
};

var getStretchedPadding = function getStretchedPadding(props) {
  if (props.isStretched && typeof props.verticalSize === 'undefined') {
    return (0, _styledComponents.css)(["padding-top:", "px;padding-bottom:", "px;"], props.size * 2, props.size * 2);
  }

  return null;
};

var StyledInset = _styledComponents["default"].div.withConfig({
  displayName: "Inset__StyledInset",
  componentId: "sc-1088k2b-0"
})(["", " padding:", ";", " ", ""], _constants.BASE_STYLES, function (props) {
  return "".concat(props.verticalSize >= 0 ? props.verticalSize : props.size, "px ").concat(props.horizontalSize >= 0 ? props.horizontalSize : props.size, "px");
}, getSquishedPadding, getStretchedPadding);

var Inset = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      tag = _ref.tag,
      props = _objectWithoutProperties(_ref, ["children", "tag"]);

  return /*#__PURE__*/_react["default"].createElement(StyledInset, _extends({
    ref: ref,
    as: tag
  }, props), children);
});

Inset.Sizes = _theming.Spacing;
Inset.propTypes = {
  size: _propTypes["default"].oneOf(Object.values(Inset.Sizes)),
  horizontalSize: _propTypes["default"].oneOf(Object.values(Inset.Sizes)),
  verticalSize: _propTypes["default"].oneOf(Object.values(Inset.Sizes)),
  isSquished: _propTypes["default"].bool,
  isStretched: _propTypes["default"].bool,
  tag: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  children: _propTypes["default"].node
};
Inset.defaultProps = {
  size: _constants.BASE_SPACING,
  isSquished: false,
  isStretched: false
};
Inset.displayName = 'Inset';
var _default = Inset;
exports["default"] = _default;